import sessionStorage from './sessionStorage';
import cookies from 'js-cookie';
export default {
  get() {
    return sessionStorage.get('userInfo') || {};
  },
  set(info) {
    sessionStorage.set('userInfo', info);
    // cookies.set('Authorization', info.accessToken);
  },
  clear() {
    sessionStorage.remove('userInfo');
    cookies.remove('admin-token')
    cookies.remove('Authorization')
  },
  setUser(data){
    cookies.set('admin-token',data)
    
  }
};
